import { useTranslation } from 'react-i18next';

export default function WhyDifferentUnified() {
  const { t } = useTranslation();
  
  return (
    <section id="why-different" className="relative py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-['Space_Grotesk']">
            {t('whyDifferent.title')}
          </h2>
        </div>

        {/* Top Row: Two Columns */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Left Column - NOT a Blocker */}
          <div className="relative p-8 rounded-2xl bg-slate-900/30 border border-slate-800/50 backdrop-blur-sm">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-red-500/30 to-transparent"></div>
            <div className="space-y-4">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-500/10">
                <i className="ri-close-circle-line text-3xl text-red-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white font-['Space_Grotesk']">{t('whyDifferent.notBlocker.title')}</h3>
              <p className="text-slate-400 leading-relaxed">
                {t('whyDifferent.notBlocker.description')}
              </p>
            </div>
          </div>

          {/* Right Column - NOT a Screen-Time Reporter */}
          <div className="relative p-8 rounded-2xl bg-slate-900/30 border border-slate-800/50 backdrop-blur-sm">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-amber-500/30 to-transparent"></div>
            <div className="space-y-4">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-500/10">
                <i className="ri-time-line text-3xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white font-['Space_Grotesk']">{t('whyDifferent.notReporter.title')}</h3>
              <p className="text-slate-400 leading-relaxed">
                {t('whyDifferent.notReporter.description')}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Row: Full Width Block */}
        <div className="relative p-10 rounded-2xl bg-gradient-to-br from-teal-900/20 to-emerald-900/20 border border-teal-500/30 backdrop-blur-sm">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-teal-500 to-transparent"></div>
          <div className="space-y-6">
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-teal-500/20">
              <i className="ri-heart-pulse-line text-4xl text-teal-400"></i>
            </div>
            <h3 className="text-3xl font-bold text-white font-['Space_Grotesk']">{t('whyDifferent.whatItIs.title')}</h3>
            <div className="space-y-4 text-base">
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-400 mt-1 text-lg"></i>
                <p className="text-slate-300 leading-relaxed">
                  <strong className="text-white">{t('whyDifferent.whatItIs.point1.title')}</strong> {t('whyDifferent.whatItIs.point1.description')}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-400 mt-1 text-lg"></i>
                <p className="text-slate-300 leading-relaxed">
                  <strong className="text-white">{t('whyDifferent.whatItIs.point2.title')}</strong> {t('whyDifferent.whatItIs.point2.description')}
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-400 mt-1 text-lg"></i>
                <p className="text-slate-300 leading-relaxed">
                  <strong className="text-white">{t('whyDifferent.whatItIs.point3.title')}</strong> {t('whyDifferent.whatItIs.point3.description')}
                </p>
              </div>
            </div>
            <p className="text-lg text-slate-300 font-light italic pt-4">
              {t('whyDifferent.whatItIs.quote')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
